import type { PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";
import { cn } from "@bcc/lib/utils";
import { CELL_LINK_CLASSES } from "../constants";

interface OrderIdCellProps extends CellContext<PurchaseOrder, unknown> {
  onViewDetails?: (order: PurchaseOrder) => void;
}

export const OrderIdCell = (props: OrderIdCellProps) => {
  const purchaseOrderId = props.getValue() as string;
  const order = props.row.original;
  return (
    <button
      type="button"
      className={cn("font-mono text-base font-semibold cursor-pointer bg-transparent border-none p-0", CELL_LINK_CLASSES)}
      onClick={(e) => {
        e.stopPropagation();
        props.onViewDetails?.(order);
      }}
    >
      {purchaseOrderId}
    </button>
  );
};
